import { useGetDemoLinksQuery, useGetPlaybookQuery } from '@carboncopyco/data';
import { DemoLinkModalBody } from './DemoLinkModalBody';
import { DemoLinkModalProvider } from './DemoLinkModalContext';
import type { DemoLinkModalProps } from './types';

export const DemoLinkPlaybookModal = (props: DemoLinkModalProps) => {
  const { data: playbook } = useGetPlaybookQuery({
    organizationId: props.organizationId,
    workspaceId: props.workspaceId,
    id: props.assetId,
  });
  const { data: demoLinks, isLoading } = useGetDemoLinksQuery({
    organizationId: props.organizationId,
    assetId: props.assetId,
    assetType: props.assetType,
  });

  const demoLink = demoLinks?.items?.[0];

  if (!playbook || isLoading) {
    return null;
  }

  return (
    <DemoLinkModalProvider
      {...props}
      link={demoLink}
      asset={playbook}
    >
      <DemoLinkModalBody />
    </DemoLinkModalProvider>
  );
};
